import { render, staticRenderFns } from "./MyBlog.vue?vue&type=template&id=bf72d182&scoped=true&"
import script from "./MyBlog.vue?vue&type=script&lang=js&"
export * from "./MyBlog.vue?vue&type=script&lang=js&"
import style0 from "./MyBlog.vue?vue&type=style&index=0&id=bf72d182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf72d182",
  null
  
)

export default component.exports